import { TEMPLATE } from 'common/constants';

function checkIsIframe() {
  return TEMPLATE === 'default.iframe';
}

export default checkIsIframe;
